<template>
  <el-dialog
    title="选择会员"
    width="400px"
    :visible.sync="dialogMember.isShow"
    append-to-body
    @opened='Opened'
  >  
    <el-form @submit.native.prevent>      
      <el-form-item >
        <el-col :span="18">
          <el-input 
            ref="number"
            prefix-icon="el-icon-search"
            placeholder="请输入会员号/手机号" 
            @keyup.enter.native="Search"
            v-model="number">             
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" v-on:click="Search" >确定</el-button>
        </el-col>
      </el-form-item>
    </el-form>  

  </el-dialog>
</template>
<script  type='text/ecmascript-6'>
   import { Loading } from 'element-ui';
   export default {
    props:{
      dialogMember:{        
      }
    },
    data(){
      return {
        number:'',
        loading:false,
        form:{}
      }
    },
    mounted(){
      
    },
    methods:{
      Opened:function(){
        this.number = ''
        this.$refs.number.focus()
      },
      Search:function(){
        this.GetData();
      },
      GetData:function(){        
        var user = this.$cookie.getJSON('user');
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/Member/Info',
          data:{
            no : that.number,
            chainStoreId: user.chainStoreId,
            merchantId: user.merchantId
          }
        }).then(function (resp) {
          if(resp.data.errorCode==0){                
            that.$emit('UpdateMember',resp.data.member)
            that.dialogMember.isShow = false
          }else{            
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      }
    }
   }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.el-button--primary
  margin-left 5px
</style>

